import { UserRoleDto } from '@/api/generated';
import { RoutesEnum } from '@/routes/Routes.enum.ts';
import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUserContext } from '../utils/providers/userContext/useUserContext';

const PATHS_TO_SKIP = ['/login', '/inactive', '/error', '/409', '/admin-login'];

export const NavigationController: React.FC<PropsWithChildren> = props => {
  const { isInitialized, user } = useUserContext();
  const navigate = useNavigate();

  const navigationInitialized = useRef(false);

  useEffect(() => {
    if (!isInitialized) {
      navigationInitialized.current = false;
      return;
    }
    if (navigationInitialized.current) {
      return;
    }

    const shouldSkipRedirect = PATHS_TO_SKIP.some(it => window.location.pathname.includes(it));
    if (shouldSkipRedirect) {
      // do nothing
    } else if (!user) {
      navigate(RoutesEnum.WELCOME);
    } else if (user?.role === UserRoleDto.Admin) {
      navigate(RoutesEnum.ADMIN);
      return;
    } else {
      navigate(RoutesEnum.QUIZ);
    }
    navigationInitialized.current = true;
  }, [user, isInitialized, navigate]);

  return <>{props.children}</>;
};
